import React, { Component } from "react";
import { Row, Col, Input, Button, Table, Drawer } from "antd";
import { withRouter } from "react-router-dom";
import { API } from "../../API/API";
import JoinWorkDoc from "./JoinWorkDoc";
class JoinWorkDtl extends Component {
  formRef = React.createRef();
  state = {
    joinname: this.props.match.params.joinname,
    joincode: this.props.match.params.joincode,
    department: this.props.match.params.department,
    typename: this.props.match.params.typename,
    startdate: this.props.match.params.startdate,
    enddate: this.props.match.params.enddate,
    joinworkid: this.props.match.params.joinworkid,
    data: [],
    showNewInputForm: false,
    selectedVendorId: 0,
    vendorName: "",
  };
  showNewInputFormHandler = (show, vendorid, vendorname) => {
    this.setState({
      showNewInputForm: show,
      selectedVendorId: vendorid,
      vendorName: vendorname
    });
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getJoinWorkListRecievedList?joinworkid=" + this.state.joinworkid).then((response) => {
      if (response.status === 200) {
        this.setState({
          data: response.data.retData,
        });
      }
    });
  };
  render() {
    const columns = [
      {
        title: "Оролцогчийн нэр",
        dataIndex: "vendorname",
        key: "vendorname",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <Button type="link" style={{ fontWeight: "500", color: "#0358A7" }}>
              {record.vendorname}
            </Button>
          );
        },
      },
      {
        title: "Төрөл",
        dataIndex: "vendortypeid",
        key: "vendortypeid",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            record.vendortypeid === 1 ? <div>ААН</div> : 
            record.vendortypeid === 2 ? <div>Хувь хүн</div> :
            <div>Гадаад</div>
          );
        },
      },
      {
        title: "Компаний статус",
        dataIndex: "activity",
        key: "activity",
        width: "10%",
        align: "left",
      },
      {
        title: "Баримт",
        dataIndex: "filecount",
        key: "filecount",
        width: "20%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              onClick={() => {
                this.showNewInputFormHandler(
                  true,
                  record.vendorid,
                  record.vendorname
                );
              }}
              type="link"
              style={{ fontWeight: "500", color: "#0358A7" }}
            >
              Хавсаргасан файл ({record.filecount})
            </Button>
          );
        },
      },
    ];
    return (
      <div className="mainContainer">
        <div className="HeaderLabel" style={{ marginBottom: 15 }}>
          Хамтран ажиллах санал | {this.state.joinname} ({this.state.joincode})
        </div>
        <Row gutter={[16, 16]}>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Захиалагч
            </div>
            <Input size="middle" value={this.state.department} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Төрөл
            </div>
            <Input size="middle" value={this.state.typename} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Зарлах огноо
            </div>
            <Input size="middle" value={this.state.startdate} />
          </Col>
          <Col span={6}>
            <div className="Label" style={{ marginBottom: 5 }}>
              Дуусах огноо
            </div>
            <Input size="middle" value={this.state.enddate} />
          </Col>
        </Row>

        <Row align="middle">
          <Col span={12}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">Оролцсон компаниудын жагсаалт</div>
              </Col>
            </Row>
          </Col>
        </Row>

        <div id="criteria">
          <Table
            dataSource={this.state.data}
            columns={columns}
            pagination={false}
            rowKey="criteriaid"
            scroll={{ y: 340 }}
          />
        </div>
        <Drawer
          title={this.state.vendorname}
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0, "")}
          destroyOnClose={true}
          style
        >
          <JoinWorkDoc
            joinworkid={this.state.joinworkid}
            vendorid={this.state.selectedVendorId}
          ></JoinWorkDoc>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(JoinWorkDtl);
